import { VeiculoFormModel } from "../modelos/veiculo/veiculoFormModel";

export const VEICULO_FORM_INITIAL_STATE: VeiculoFormModel = {
  numeroAssentos: 0,
  placa: "",
  tipo: "",
  ano: null,
};
  